import * as Blockly from 'blockly/core';
import { blockElse, blockElseIf, blockIf } from '@/(routers)/boards/editor/block/generators/arduino/_gen';

export function register(gen: any): void {
    gen.forBlock['if'] = function (block: Blockly.Block): string {
        const elseIfIds = (block as any)._elseIfIds as string[];
        const hasElse = (block as any)._hasElse as boolean;

        let code = '';

        const cond0 = gen.valueToCode(block, 'IF0', 0) || 'false';
        const do0 = gen.statementToCode(block, 'DO0');
        code += blockIf(cond0, do0).trimEnd();

        for (const id of elseIfIds) {
            const cond = gen.valueToCode(block, `IF_${id}`, 0) || 'false';
            const doI = gen.statementToCode(block, `DO_${id}`);
            code += blockElseIf(cond, doI);
        }

        if (hasElse) {
            const doElse = gen.statementToCode(block, 'ELSE');
            code += blockElse(doElse);
        }

        return code + '\n';
    };
}
